(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lookbook-gallery')) {
    customElements.define('lookbook-gallery', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-grid]');
        if (!this.grid) return;
        const design = window.Shopify && window.Shopify.designMode;
        if (this.hasAttribute('data-shuffle')) this.shuffle();
        this.reslot();
        const initial = parseInt(this.dataset.initial, 10) || 0;
        const more = this.querySelector('[data-more]');
        if (initial > 0 && !design) {
          this.items().forEach((li, i) => { if (i >= initial) li.hidden = true; });
          if (more) more.addEventListener('click', () => {
            const hidden = this.items().filter((li) => li.hidden);
            hidden.slice(0, initial).forEach((li) => { li.hidden = false; li.classList.add('is-in'); });
            if (hidden.length <= initial) more.parentElement.remove();
          });
        } else if (more) {
          more.parentElement.remove();
        }
      }
      items() { return [...this.grid.children]; }
      shuffle() {
        const pinned = this.items().filter((li) => li.hasAttribute('data-pinned'));
        const rest = this.items().filter((li) => !li.hasAttribute('data-pinned'));
        for (let i = rest.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [rest[i], rest[j]] = [rest[j], rest[i]];
        }
        [...pinned, ...rest].forEach((li) => this.grid.appendChild(li));
      }
      reslot() {
        this.items().forEach((li, i) => { li.dataset.slot = String((i + 1) % 6); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
